import { Nomination } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getNominationById: (
  fetchContext: FetchContext,
  nominationId: number,
  accessToken?: string,
) => Promise<Nomination> = (fetchContext, nominationId, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/nominations/${nominationId}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<Nomination>(fetchContext.errorStore, response, 'get nomination by id'));
